import { gql } from 'graphql-request'

export const CRIAR_NOVA_PASTA = gql`
  mutation CriarNovaPastaMutation($novaPasta: NovaPastaInput!) {
    criarNovaPasta(novaPasta: $novaPasta) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
